function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import values from 'lodash/values';
import moment from 'moment';
import useStyles from 'isomorphic-style-loader/useStyles';
import { KPI_TYPES } from '../../../../constants';
import messages from '../../../../messages';
import { createReadingsKPIData, calculateMedicationsKPIData } from '../../../../helpers/kpi';
import Cell from './Cells/Cell';
import styles from './Header.pcss';
const KPIs = ({ startDayTimestamp, weekNumber, standards, conversion, readingsWithRelatedData, translatedTimeSeriesResources })=>{
    useStyles(styles);
    const { criticalHighReadingsNumber, criticalLowReadingsNumber, standardDeviation, readingsInRangeRatio, preMealAverage, strictPostMealAverage, readingsAverage } = createReadingsKPIData(readingsWithRelatedData, conversion, standards);
    const { fastActingRatio, longActingRatio } = calculateMedicationsKPIData(readingsWithRelatedData.map((r)=>r.relatedData || {}), values(translatedTimeSeriesResources));
    const startMoment = moment.unix(startDayTimestamp).utc();
    const endMoment = startMoment.clone().add(6, 'days');
    const formattedStart = startMoment.format('MMM DD, YYYY');
    const formattedEnd = endMoment.format('MMM DD, YYYY');
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.KPIsContainter,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "d-flex flex-column",
                children: [
                    /*#__PURE__*/ _jsxs("h1", {
                        className: "text--uppercase mb-3",
                        children: [
                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.week)),
                            ` ${weekNumber}`
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsxs("span", {
                            children: [
                                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.from)),
                                "  ",
                                `: ${formattedStart}`,
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsxs("span", {
                            children: [
                                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.to)),
                                " ",
                                `: ${formattedEnd}`,
                                " "
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.KPIs,
                children: [
                    /*#__PURE__*/ _jsx(Cell, {
                        value: [
                            fastActingRatio,
                            longActingRatio
                        ],
                        type: KPI_TYPES.INJECTIONS,
                        standards: standards,
                        conversion: conversion
                    }),
                    /*#__PURE__*/ _jsx(Cell, {
                        value: criticalHighReadingsNumber,
                        type: KPI_TYPES.VERY_HIGH,
                        standards: standards,
                        conversion: conversion
                    }),
                    /*#__PURE__*/ _jsx(Cell, {
                        value: criticalLowReadingsNumber,
                        type: KPI_TYPES.VERY_LOW,
                        standards: standards,
                        conversion: conversion
                    }),
                    /*#__PURE__*/ _jsx(Cell, {
                        value: standardDeviation,
                        type: KPI_TYPES.STANDARD_DEVIATION,
                        standards: standards,
                        conversion: conversion
                    }),
                    /*#__PURE__*/ _jsx(Cell, {
                        value: readingsInRangeRatio,
                        type: KPI_TYPES.PERSENT_OF_READING_IN_RANGE,
                        standards: standards,
                        conversion: conversion
                    }),
                    /*#__PURE__*/ _jsx(Cell, {
                        value: preMealAverage,
                        type: KPI_TYPES.AVERAGE_PRE_MEAL,
                        standards: standards,
                        conversion: conversion
                    }),
                    /*#__PURE__*/ _jsx(Cell, {
                        value: strictPostMealAverage,
                        type: KPI_TYPES.AVERAGE__STRICT_POST_MEAL,
                        standards: standards,
                        conversion: conversion
                    }),
                    /*#__PURE__*/ _jsx(Cell, {
                        value: readingsAverage,
                        type: KPI_TYPES.AVERAGE_OVERALL,
                        standards: standards,
                        conversion: conversion
                    })
                ]
            })
        ]
    });
};
export default KPIs;
